"use strict";

var _toConsumableArray = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _regeneratorRuntime = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _slicedToArray = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFluidImageObject = exports.getFixedImageObject = exports.getSharedImageData = exports.getAspectRatio = exports.getImageURL = exports.DEFAULT_FLUID_MAX_WIDTH = exports.DEFAULT_BASE64_WIDTH = void 0;

var axios_1 = __importDefault(require("axios"));

var buffer_1 = __importDefault(require("buffer"));

var Buffer = buffer_1.default.Buffer;
exports.DEFAULT_BASE64_WIDTH = 30;
var DEFAULT_FIXED_WIDTH = 400;
exports.DEFAULT_FLUID_MAX_WIDTH = 1080;

var getImageURL = function getImageURL(_ref) {
  var _ref$chained = _ref.chained,
      chained = _ref$chained === void 0 ? [] : _ref$chained,
      _ref$defaults = _ref.defaults,
      defaults = _ref$defaults === void 0 ? [] : _ref$defaults,
      origin = _ref.origin,
      path = _ref.path,
      _ref$transformations = _ref.transformations,
      transformations = _ref$transformations === void 0 ? [] : _ref$transformations,
      _ref$version = _ref.version,
      version = _ref$version === void 0 ? false : _ref$version;
  var baseURL = "".concat(origin, "/");
  var allTransformations = [transformations.concat(defaults).join()].concat(chained).join('/');
  var imagePath = [allTransformations, version ? "/v".concat(version, "/") : '/', path].join('').replace('//', '/');

  if ('undefined' !== typeof btoa) {
    return "".concat(baseURL).concat(btoa(imagePath));
  }

  return "".concat(baseURL).concat(Buffer.from(imagePath).toString('base64'));
};

exports.getImageURL = getImageURL;

var getBase64 = function getBase64(_ref2) {
  var _ref2$chained = _ref2.chained,
      chained = _ref2$chained === void 0 ? [] : _ref2$chained,
      _ref2$defaults = _ref2.defaults,
      defaults = _ref2$defaults === void 0 ? [] : _ref2$defaults,
      origin = _ref2.origin,
      path = _ref2.path,
      _ref2$transformations = _ref2.transformations,
      transformations = _ref2$transformations === void 0 ? [] : _ref2$transformations,
      _ref2$version = _ref2.version,
      version = _ref2$version === void 0 ? false : _ref2$version;
  var baseURL = "".concat(origin, "/");
  var allTransformations = [transformations.concat('w_30').concat(defaults).join()].concat(chained).join('/');
  var imagePath = [allTransformations, version ? "/v".concat(version, "/") : '/', path].join('').replace('//', '/');
  return axios_1.default.get("".concat(baseURL).concat(btoa(imagePath)), {
    responseType: 'arraybuffer'
  }).then(function (res) {
    var data = Buffer.from(res.data).toString('base64');
    return "data:image/jpeg;base64,".concat(data);
  }).catch(function () {
    return "".concat(baseURL).concat(btoa(imagePath));
  });
};

var getAspectRatio = function getAspectRatio(transformations, originalAspectRatio) {
  var rTransform = transformations.find(function (t) {
    return t.startsWith('r_');
  });

  if (rTransform) {
    return parseFloat(rTransform.replace('r_', ''));
  }

  var arTransform = transformations.find(function (t) {
    return t.startsWith('ar_');
  });

  if (!arTransform) {
    return originalAspectRatio;
  }

  var newAspectRatio = arTransform.replace('ar_', '');

  if (-1 === newAspectRatio.indexOf(':')) {
    return Number(newAspectRatio);
  }

  if (!newAspectRatio) {
    return 1;
  }

  var _newAspectRatio$split = newAspectRatio.split(':').map(Number),
      _newAspectRatio$split2 = _slicedToArray(_newAspectRatio$split, 2),
      w = _newAspectRatio$split2[0],
      h = _newAspectRatio$split2[1];

  return w / h;
};

exports.getAspectRatio = getAspectRatio;

var getSharedImageData = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
    var chained, origin, path, transformations, version, base64, src;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            chained = _ref3.chained, origin = _ref3.origin, path = _ref3.path, transformations = _ref3.transformations, version = _ref3.version;
            _context.next = 3;
            return getBase64({
              origin: origin,
              path: path,
              transformations: transformations
            });

          case 3:
            base64 = _context.sent;
            src = (0, exports.getImageURL)({
              chained: chained,
              origin: origin,
              path: path,
              transformations: transformations,
              version: version
            });
            return _context.abrupt("return", {
              base64: base64,
              src: src
            });

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getSharedImageData(_x) {
    return _ref4.apply(this, arguments);
  };
}();

exports.getSharedImageData = getSharedImageData;

var getFixedImageObject = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref5) {
    var _ref5$chained, chained, _ref5$base64Width, base64Width, _ref5$base64Transform, base64Transformations, origin, path, _ref5$transformations, transformations, _ref5$version, version, _ref5$width, width, _yield, base64, src, aspectRatio, sizes, srcSet;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref5$chained = _ref5.chained, chained = _ref5$chained === void 0 ? [] : _ref5$chained, _ref5$base64Width = _ref5.base64Width, base64Width = _ref5$base64Width === void 0 ? exports.DEFAULT_BASE64_WIDTH : _ref5$base64Width, _ref5$base64Transform = _ref5.base64Transformations, base64Transformations = _ref5$base64Transform === void 0 ? [] : _ref5$base64Transform, origin = _ref5.origin, path = _ref5.path, _ref5$transformations = _ref5.transformations, transformations = _ref5$transformations === void 0 ? [] : _ref5$transformations, _ref5$version = _ref5.version, version = _ref5$version === void 0 ? false : _ref5$version, _ref5$width = _ref5.width, width = _ref5$width === void 0 ? DEFAULT_FIXED_WIDTH : _ref5$width;
            _context2.next = 3;
            return (0, exports.getSharedImageData)({
              base64Transformations: base64Transformations,
              base64Width: base64Width,
              chained: chained,
              origin: origin,
              path: path,
              transformations: transformations,
              version: version
            });

          case 3:
            _yield = _context2.sent;
            base64 = _yield.base64;
            src = _yield.src;
            aspectRatio = (0, exports.getAspectRatio)(transformations, 1);
            sizes = [1, 1.5, 2, 3].map(function (size) {
              return {
                resolution: size,
                width: width * size
              };
            });
            srcSet = sizes.map(function (size) {
              var url = (0, exports.getImageURL)({
                chained: chained,
                origin: origin,
                path: path,
                version: version,
                transformations: transformations.concat("w_".concat(size.width))
              });
              return "".concat(url, " ").concat(size.resolution, "x");
            }).join();
            return _context2.abrupt("return", {
              base64: base64,
              src: src,
              srcSet: srcSet,
              width: width,
              height: width / aspectRatio
            });

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getFixedImageObject(_x2) {
    return _ref6.apply(this, arguments);
  };
}();

exports.getFixedImageObject = getFixedImageObject;

var getFluidImageObject = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref7) {
    var _ref7$base64Transform, base64Transformations, _ref7$base64Width, base64Width, _ref7$breakpoints, breakpoints, _ref7$chained, chained, _ref7$maxWidth, maxWidth, origin, path, _ref7$transformations, transformations, _ref7$version, version, max, sizes, _yield2, base64, src, aspectRatio, cleaned, deduped, srcSet;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _ref7$base64Transform = _ref7.base64Transformations, base64Transformations = _ref7$base64Transform === void 0 ? [] : _ref7$base64Transform, _ref7$base64Width = _ref7.base64Width, base64Width = _ref7$base64Width === void 0 ? exports.DEFAULT_BASE64_WIDTH : _ref7$base64Width, _ref7$breakpoints = _ref7.breakpoints, breakpoints = _ref7$breakpoints === void 0 ? [200, 400, 600] : _ref7$breakpoints, _ref7$chained = _ref7.chained, chained = _ref7$chained === void 0 ? [] : _ref7$chained, _ref7$maxWidth = _ref7.maxWidth, maxWidth = _ref7$maxWidth === void 0 ? exports.DEFAULT_FLUID_MAX_WIDTH : _ref7$maxWidth, origin = _ref7.origin, path = _ref7.path, _ref7$transformations = _ref7.transformations, transformations = _ref7$transformations === void 0 ? [] : _ref7$transformations, _ref7$version = _ref7.version, version = _ref7$version === void 0 ? false : _ref7$version;
            max = Math.min(maxWidth);
            sizes = "(max-width: ".concat(max, "px) 100vw, ").concat(max, "px");
            _context3.next = 5;
            return (0, exports.getSharedImageData)({
              base64Transformations: base64Transformations,
              base64Width: base64Width,
              breakpoints: breakpoints,
              chained: chained,
              origin: origin,
              path: path,
              transformations: transformations,
              version: version
            });

          case 5:
            _yield2 = _context3.sent;
            base64 = _yield2.base64;
            src = _yield2.src;
            aspectRatio = (0, exports.getAspectRatio)(transformations, 1);
            cleaned = breakpoints.concat(max).filter(function (w) {
              return w <= max;
            }).sort(function (a, b) {
              return a - b;
            });
            deduped = _toConsumableArray(Array.from(new Set(cleaned)));
            srcSet = deduped.map(function (breakpointWidth) {
              var url = (0, exports.getImageURL)({
                chained: chained,
                origin: origin,
                path: path,
                version: version,
                transformations: transformations.concat("w_".concat(breakpointWidth))
              });
              return "".concat(url, " ").concat(breakpointWidth, "w");
            }).join();
            return _context3.abrupt("return", {
              aspectRatio: aspectRatio,
              base64: base64,
              sizes: sizes,
              src: src,
              srcSet: srcSet
            });

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getFluidImageObject(_x3) {
    return _ref8.apply(this, arguments);
  };
}();

exports.getFluidImageObject = getFluidImageObject;